import { message } from 'ant-design-vue/'
import { throttle } from 'lodash-es'

const success = throttle(message.success, 3500)
const error = throttle(message.error, 3500)
const info = throttle(message.info, 3500)
const warn = throttle(message.warn, 3500)
const warning = throttle(message.warning, 3500)
const loading = throttle(message.loading, 3500)

class MessageTips {
  success(content: string, ...args: any[]) {
    success(content, ...args)
  }

  error(content: string, ...args: any[]) {
    error(content, ...args)
  }

  info(content: string, ...args: any[]) {
    info(content, ...args)
  }

  warn(content: string, ...args: any[]) {
    warn(content, ...args)
  }

  warning(content: string, ...args: any[]) {
    warning(content, ...args)
  }

  loading(content: string, ...args: any[]) {
    loading(content, ...args)
  }
}

export default new MessageTips()
